// ---------------------------------------------------------------------------
// Which chapter the reader is in.
//
// On one long page the stepper is not navigation, it is a position. An observer
// watches the four chapters and marks whichever one owns the top of the screen.
//
// The address bar deliberately does not follow. Writing the chapter into the URL
// would be a nice thing for a copied link to carry, but Chrome scrolls to the
// fragment even when it arrives through replaceState, so the page jumped past
// its own opening the moment the first chapter was marked.
// ---------------------------------------------------------------------------

export function chapterSpy() {
    const steps = [...document.querySelectorAll('.stepper__step[data-step]')]
    const chapters = steps
        .map((step) => document.getElementById(step.dataset.step))
        .filter(Boolean)

    if (chapters.length !== steps.length || !chapters.length) return

    const mark = (id) => {
        for (const step of steps) step.classList.toggle('is-current', step.dataset.step === id)
    }

    // A band across the top quarter of the viewport decides. The observer only
    // reports what changed, and not in document order, so what is currently
    // crossing the band is kept here and read back in the order of the chapters.
    const crossing = new Set()

    const observer = new IntersectionObserver(
        (entries) => {
            for (const entry of entries) {
                if (entry.isIntersecting) crossing.add(entry.target.id)
                else crossing.delete(entry.target.id)
            }

            const current = chapters.find((chapter) => crossing.has(chapter.id))
            if (current) mark(current.id)
        },
        { rootMargin: '-20% 0px -75% 0px', threshold: 0 }
    )

    chapters.forEach((chapter) => observer.observe(chapter))
    mark(chapters[0].id)
}


// ---------------------------------------------------------------------------
// The header condenses once the reader has left the top of the page: the title
// and the claim fold away and the strip carries on alone.
//
// A sentinel in front of the header rather than the header itself, because a
// sticky element never stops intersecting the viewport — that is the point of
// it — so there is nothing to observe on it.
// ---------------------------------------------------------------------------

export function condenseHeader() {
    const sentinel = document.querySelector('.dash-top__sentinel')
    const header = document.querySelector('.dash-top')

    if (!sentinel || !header) return

    const observer = new IntersectionObserver(
        ([entry]) => header.classList.toggle('is-stuck', !entry.isIntersecting),
        { threshold: 0 }
    )

    observer.observe(sentinel)
}
